import axios from 'axios';

const ActualiteService = {}

ActualiteService.ajouter =(formData,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/actualite/ajouter`, formData ,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
}) 

}
export default ActualiteService ;